import { useEffect } from "react"
import { useDispatch } from "react-redux";
import { traerUserAutogestion } from "../../actions/autogestion/userAutogestion";
import { Step1 } from "./Step1";

export const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(traerUserAutogestion());
    // eslint-disable-next-line
  }, [])

  return (
    <Step1></Step1>
  )
}